import React from 'react';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

import GlobalData from '../context/globaldata';

import Header from "../components/Header";

import defaultUserSettings from "../static/defaultUserSettings.json";
import themes from "../static/themes.json";

const customFormSelect = {
  option: (provided, state) => ({
    ...provided
  }),
  input: (styles, { data }) => {
    return {
      ...styles,
      margin: 0
    }
  },
  placeholder: (styles, { data }) => {
    return {
      ...styles,
      fontSize: 17
    }
  }
}

class User extends React.Component {
  static contextType = GlobalData;

  constructor(props) {
    super(props);
    this.state = {
      devices: [],
      favoriteDevice: {
        "label": ""
      },
      favoriteGrinder: {
        "label": ""
      },
      grinders: [],
      saving: false,
      userSettings: defaultUserSettings
    };

    this.favoriteDevice = {};
    this.favoriteGrinder = {};
  };

  componentDidMount() {
    this.userQuery = this.context.db.collection('users').doc(this.context.currentUser.uid);
    this.getDevices('devices');
    this.getDevices('grinders');
    this.getFavoriteDevice('devices', 'favoriteDevice', this.favoriteDevice);
    this.getFavoriteGrinder('grinders', 'favoriteGrinder', this.favoriteGrinder);
  };

  componentDidUpdate(prevProps, prevState) {
    if(this.context.userSettings !== null && this.context.userSettings !== prevState.userSettings) {
      this.setState({
        userSettings: this.context.userSettings
      });
    }
  };

  componentWillUnmount() {
    this.databaseSnapshot();
  };

  getDevices = (type) => {
    const collection = this.userQuery.collection(type);

    this.databaseSnapshot = collection.onSnapshot(querySnapshot => {
      querySnapshot.forEach(doc => {
        let userData = doc.data();

        if(userData.reference) {
          userData.reference.get().then((reference) => {
            this.setState(prevState => {
              var containsElement = prevState[type].map(item => item.label).includes(reference.data().label);

              if(!containsElement) {
                return {
                  [type]: [
                    ...this.state[type],
                    {
                      ...reference.data(),
                      deviceReference: reference.ref,
                      userReference: doc.ref
                    }
                  ]
                }
              } else {
                return false
              }
            });
          })
        }
      });
    });
  };

  handleCreate = (type, inputValue) => {
    this.context.db.collection(type).add({
      label: inputValue
    }).then((device) => {
      this.userQuery.collection(type).add({
        favorite: false,
        reference: this.context.db.doc(device.path)
      });
    });
  };

  handleChange = (type, newValue, actionMeta) => {
    // TODO: After removing device/grinder from list, check if favorite is still available.

    if(actionMeta) {
      if(actionMeta.action === 'remove-value' || actionMeta.action === 'pop-value') {
        actionMeta.removedValue.deviceReference.delete();
        actionMeta.removedValue.userReference.delete();

        var array = [...this.state[type]];
        var index = array.indexOf(actionMeta.removedValue);

        if(index !== -1) {
          array.splice(index, 1);
          this.setState({
            [type]: array
          });
        }
      }
    } else {

    if(newValue.name === 'favorite_device') {
      this.favoriteDevice.get().then(reference => {
        if(!reference.empty) {
          reference.docs[0].ref.update({
            favorite: false
          });
        }
      });
      type.userReference.get().then(reference => {
        reference.ref.update({
          favorite: true
        })
      });
    }

    if(newValue.name === 'favorite_grinder') {
      debugger
      this.favoriteGrinder.get().then(reference => {
        debugger
        if(!reference.empty) {
          reference.docs[0].ref.update({
            favorite: false
          });
        }
      });
      type.userReference.get().then(reference => {
        reference.ref.update({
          favorite: true
        })
      });
    }

    }

    if(type === 'subscription') {
      this.context.updateUserSettings(newValue, 'subscription')
    }
  };

  getFavoriteDevice(collectionName, stateKey, queryVariable) {
    this.favoriteDevice = this.userQuery.collection(collectionName).where('favorite', '==', true);
    this.favoriteDevice.onSnapshot(querySnapshot => {

      if(querySnapshot.size > 0) {
        querySnapshot.docs[0].data().reference.get().then((doc) => {
          this.setState({
            [stateKey]: doc.data()
          });
        })
      }
    });
  };

  getFavoriteGrinder(collectionName, stateKey, queryVariable) {
    this.favoriteGrinder = this.userQuery.collection(collectionName).where('favorite', '==', true);
    this.favoriteGrinder.onSnapshot(querySnapshot => {

      if(querySnapshot.size > 0) {
        querySnapshot.docs[0].data().reference.get().then((doc) => {
          this.setState({
            [stateKey]: doc.data()
          });
        })
      }
    });
  };

  render() {
    if(!this.context.userSettings && !this.state.userSettings) {
      return null
    }

    return (
      <div className={ `settings ${ this.state.saving ? 'is-saving' : '' }` }>
        <Header className="header header--primary" title="Settings">
            <div className="header__actions">
              <button className={`button button--primary ${ this.state.saving ? 'is-loading' : '' }`} onClick={ this.saveSettings }>
                <span>Save changes</span>
              </button>
            </div>
        </Header>
        <form className="settings__container form">
          <div className="form__section">
            <div className="form__block">
              <div className="form__column form__column--small">
                <label className="form__label">
                  <span>Language/locale</span>
                  <input className="form__input" name="locale" type="text" defaultValue={ this.state.userSettings.locale } />
                </label>
              </div>
              <div className="form__column form__column--small">
                <label className="form__label">
                  <span>Temperature unit</span>
                  <input className="form__input" name="temperature_unit" type="text" defaultValue={ this.state.userSettings.temperature_unit } />
                </label>
              </div>
              <div className="form__column form__column--small">
                <label className="form__label">
                  <span>Weight unit</span>
                  <input className="form__input" name="weight_unit" type="text" defaultValue={ this.state.userSettings.weight_unit } />
                </label>
              </div>
              <div className="form__column form__column--large">
                <label className="form__label">
                  <span>Theme</span>
                  <Select className="form-select" name="roast" defaultValue={ this.state.userSettings.theme } getOptionValue={ option => option.value } classNamePrefix="form-select" styles={ customFormSelect } onChange={ (event) => this.context.updateUserSettings(event, 'theme') } options={ themes } />
                </label>
              </div>
              <div className="form__column form__column--small">
                <label className="form__label">
                  <span>Date format</span>
                  <input className="form__input" name="date_format" type="text" value={ this.state.userSettings.date_format } onChange={ (event) => this.context.updateUserSettings(event, 'date_format') } />
                </label>
              </div>
              { this.state.userSettings.premium_user &&
                <div className="form__column form__column--full">
                  <div className="form__label">
                    <span>Prefer advanced charts/flavours</span>
                    <label className="switch">
                      <input className="switch__input" name="prefers_advanced_flavours" type="checkbox" checked={ this.state.userSettings.prefers_advanced_flavours } onChange={ (event) => this.context.updateUserSettings(event, 'prefers_advanced_flavours') } />
                      <div className="switch__element"></div>
                    </label>
                  </div>
                </div>
              }
              <div className="form__column form__column--medium">
                <div className="form__label">
                  <span>Brew devices</span>
                  <CreatableSelect
                    name="devices"
                    className="form-select form-select--hide-indicator"
                    classNamePrefix="form-select"
                    styles={ customFormSelect }
                    onCreateOption={ this.handleCreate.bind(this, 'devices') }
                    getOptionValue={ option => option.label }
                    isClearable={ false }
                    isMulti
                    onChange={ this.handleChange.bind(this, 'devices') }
                    value={ this.state.devices }
                    noOptionsMessage={ () => null }
                  />
                </div>
              </div>
              <div className="form__column form__column--medium">
                <div className="form__label">
                  <span>Grinders</span>
                  <CreatableSelect
                    name="grinders"
                    className="form-select form-select--hide-indicator"
                    classNamePrefix="form-select"
                    styles={ customFormSelect }
                    onCreateOption={ this.handleCreate.bind(this, 'grinders') }
                    getOptionValue={ option => option.label }
                    isClearable={ false }
                    isMulti
                    onChange={ this.handleChange.bind(this, 'grinders') }
                    value={ this.state.grinders }
                    noOptionsMessage={ () => null }
                  />
                </div>
              </div>
              <div className="form__column form__column--medium">
                <div className="form__label">
                  <span>Favorite brew device</span>
                  <Select
                    name="favorite_device"
                    className="form-select"
                    value={ this.state.favoriteDevice }
                    getOptionValue={ option => option.label }
                    classNamePrefix="form-select"
                    styles={ customFormSelect }
                    onChange={ this.handleChange }
                    options={ this.state.devices }
                  />
                </div>
              </div>
              <div className="form__column form__column--medium">
                <div className="form__label">
                  <span>Favorite grinder</span>
                  <Select
                    name="favorite_grinder"
                    className="form-select"
                    value={ this.state.favoriteGrinder }
                    getOptionValue={ option => option.label }
                    classNamePrefix="form-select"
                    styles={ customFormSelect }
                    onChange={ this.handleChange }
                    options={ this.state.grinders }
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="form__section form__section--aside">
            <div className="form__block form__block--secondary">
              <div className="form__column form__column--full">
                <label className="form__label">
                  <span>Amount of brews</span>
                  <input
                    className="form__input"
                    value={ `${ this.context.brewAmountTotal }${ !this.state.userSettings.premium_user ? '/50' : '' }` }
                    disabled
                  />
                </label>
              </div>
              <div className="form__column form__column--full">
                <div className="form__label">
                  <span>Premium user</span>
                  <label className="switch">
                    <input className="switch__input" name="premium_user" type="checkbox" checked={ this.state.userSettings.premium_user } onChange={ (event) => this.context.updateUserSettings(event, 'premium_user') } />
                    <div className="switch__element"></div>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default User;
